import { clsx } from "clsx";

export const sizes = {
	"2xs": "p-1 text-xs leading-4",
	xs: "px-2.5 py-1.5 text-xs leading-4",
	sm: "px-3 py-2 text-sm leading-4",
	md: "px-6 py-2 text-md leading-5",
	lg: "px-6 py-2 text-lg leading-6",
	xl: "px-6 py-3 text-xl leading-6",
	inline: "",
};

export const roundedness = {
	none: "",
	sm: "rounded-sm",
	rounded: "rounded",
	md: "rounded-md",
	lg: "rounded-lg",
	xl: "rounded-xl",
	"2xl": "rounded-2xl",
	"3xl": "rounded-3xl",
	full: "rounded-full",
};

export const variants = {
	primary: {
		span: "inline-flex",
		button: clsx(
			"inline-flex items-center justify-center font-medium transition-all ease-in-out duration-150 antialiased  text-white",
			"disabled:cursor-not-allowed",
			"bg-opus-blue-100"
		),
	},
	secondary: {
		span: "inline-flex",
		button: clsx(
			"inline-flex justify-center items-center font-medium transition-all border-2 border-opus-blue-100 border ease-in-out duration-150 antialiased shadow-md text-opus-blue-100 ",
			"disabled:cursor-not-allowed",
			"bg-white"
		),
	},
	gradient: {
		span: "inline-flex",
		button: clsx(
			"inline-flex justify-center items-center font-medium transition-all  border ease-in-out duration-150 antialiased  text-white ",
			"disabled:cursor-not-allowed",
			"bg-gradient-to-tr from-opus-blue-200  to-opus-blue-100"
		),
	},
	green: {
		span: "inline-flex",
		button: clsx(
			"inline-flex justify-center items-center font-medium transition-all  ease-in-out duration-150 antialiased  text-white ",
			"disabled:cursor-not-allowed",
			"bg-opus-green-100 "
		),
	},
	white: {
		span: "inline-flex",
		button: clsx(
			"inline-flex justify-center items-center font-medium transition-all ease-in-out duration-150 antialiased  ",
			"disabled:cursor-not-allowed",
			"bg-white"
		),
	},
};
